import React from "react";

// Static image paths from public folder
const MastercardIcon = "/assets/img/payment_form_icons/mastercard_icon.svg";
const VisaIcon = "/assets/img/payment_form_icons/visa_card_icon.svg";

/** Processes the card validator result and displays relevant CC type image */
export default function Card({ type }) {
	return (
		<div className="cards">
			<img src={MastercardIcon} alt="MasterCard" style={{ width: 40, height: 25 }} />
			<img src={VisaIcon} alt="Visa Card" style={{ width: 40, height: 25 }} />
		</div>
	);
}
